import React, { ReactElement, ReactNode } from "react";
import {
    RiAddFill, RiAddLine, RiArrowDownSLine, RiErrorWarningFill, RiSendPlaneFill, RiTreeFill,
} from "react-icons/ri";

// eslint-disable-next-line import/no-extraneous-dependencies
import { RiSearchLine } from "@remixicon/react";
import Button, { SIZES as BUTTON_SIZES, VARIANT as BUTTON_VARIANT } from "../../../../components/theme/button/Button";
import Alert, { VARIANT as ALERT_VARIENT } from "../../../../components/theme/alert/Alert";
import Toggle, { VARIANT as TOGGLE_VARIANT, SIZES as TOGGLE_SIZES } from "../../../../components/theme/toggle/Toggle";
import Badge, { VARIANT as BADGE_VARIANT, SIZES as BADGE_SIZES } from "../../../../components/theme/badge/Badge";
import FormGroup, { SIZES as INPUT_SIZES, VARIANT as INPUT_VARIANTS } from "../../../../components/theme/form-group/FormGroup";

import { Navigation } from "../../../../components";

function AllNavigation(): ReactElement {
    return (
        <div className="">
            <Navigation shouldDisplayOnSide />
        </div>
    );
}

function AllInputs(): ReactElement {
    const eachSize = (label: string, handler: ((size: "small" | "medium" | "filter") => ReactNode)) => (
        <div className="d-flex gap-4 mb-2 border-bottom">
            <div className="col-2">{label}</div>
            { INPUT_SIZES.map(size => handler(size)) }
        </div>
    );
    return (
        <div className="border p-2">
            {INPUT_VARIANTS.map(variant => (
                <div>
                    {eachSize(variant, size => (
                        <div className="col-3">
                            <h5>{size}</h5>
                        </div>
                    ))}
                    {eachSize(`Default`, size => (
                        <FormGroup
                            groupClassName="col-3"
                            variant={variant}
                            size={size}
                            label="Label"
                            isRequired
                            type="text"
                            helpText="Helper Text"
                        />
                    ))}
                    {eachSize(`Active`, size => (
                        <FormGroup
                            groupClassName="col-3"
                            variant={variant}
                            size={size}
                            label="Label"
                            isRequired
                            type="text"
                            helpText="Helper Text"
                            className="active"
                        />
                    ))}
                    {eachSize(`Disabled`, size => (
                        <FormGroup
                            groupClassName="col-3"
                            variant={variant}
                            size={size}
                            label="Label"
                            isRequired
                            type="text"
                            defaultValue="i like cake"
                            isDisabled
                            helpText="Helper Text"
                        />
                    ))}
                    {eachSize(`Placeholder`, size => (
                        <FormGroup
                            groupClassName="col-3"
                            variant={variant}
                            size={size}
                            label="Label"
                            isRequired
                            type="text"
                            placeholder="Placeholder text..."
                            helpText="Helper Text"
                        />
                    ))}

                    {eachSize(`Search`, size => (
                        <FormGroup
                            groupClassName="col-3"
                            variant={variant}
                            size={size}
                            label="Label"
                            isRequired
                            type="search"
                            prefixIcon={<RiSearchLine />}
                            placeholder="Placeholder text..."
                            helpText="Helper Text"
                        />
                    ))}

                </div>
            ))}
        </div>
    );
}

function AllAlerts(): ReactElement {
    return (
        <div className="border p-2">
            {ALERT_VARIENT.map(variant => (
                <div>
                    <h5>{variant}</h5>
                    <div className="d-flex gap-2">
                        <Alert variant={variant} className="col-6">You can add multiple child Customers.</Alert>
                        <Alert
                            variant={variant}
                            className="col-6"
                            prefixIcon={<RiErrorWarningFill />}
                        >
                            You can add multiple child Customers.
                        </Alert>
                    </div>
                    <div className="d-flex gap-2">
                        <Alert
                            variant={variant}
                            className="col-6"
                            onClose={() => {
                                // do nothin
                            }}
                        >
                            You can add multiple child Customers.
                        </Alert>
                        <Alert
                            variant={variant}
                            actionText="Undo"
                            className="col-6"
                            prefixIcon={<RiErrorWarningFill />}
                            onActionClick={() => {
                                // do nothin
                            }}
                            onClose={() => {
                            // do nothing
                            }}
                        >
                            You can add multiple child Customers.
                        </Alert>
                    </div>
                </div>
            ))}
        </div>
    );
}

function AllToggles(): ReactElement {
    return (
        <div className="border p-2">
            {TOGGLE_SIZES.map(size => (
                <div className="mb-4">
                    {TOGGLE_VARIANT.map(variant => (
                        <div>

                            <div className="d-flex gap-2 mb-1">
                                <div className="col-2">
                                    {size}
                                    {" "}
                                    -
                                    {" "}
                                    {variant}
                                </div>
                                <Toggle variant={variant} size={size} defaultChecked />
                                <Toggle variant={variant} size={size} defaultChecked disabled />
                                <Toggle variant={variant} size={size} />
                                <Toggle variant={variant} size={size} disabled />
                            </div>

                        </div>
                    ))}
                </div>
            ))}

        </div>
    );
}

function AllBadges(): ReactElement {
    return (
        <div className="border p-2">

            {BADGE_VARIANT.map(variant => (
                <div className="d-flex gap-2 mb-1">
                    {BADGE_SIZES.map(size => (

                        < >
                            <div className="col-2">
                                {size}
                                {" "}
                                -
                                {" "}
                                {variant}
                            </div>
                            <Badge variant={variant} size={size}>Tag</Badge>
                            <Badge
                                variant={variant}
                                size={size}
                                prefixIcon={<RiTreeFill />}
                                postfixIcon={<RiArrowDownSLine />}
                            >
                                Tag
                            </Badge>
                            <Badge variant={variant} size={size} prefixIcon={<RiTreeFill />}>Tag</Badge>
                            <Badge variant={variant} size={size} postfixIcon={<RiArrowDownSLine />}>Tag</Badge>
                        </>
                    ))}
                </div>
            ))}

        </div>
    );
}

function AllButtons(): ReactElement {
    return (
        <div className="border p-2">
            {BUTTON_VARIANT.map(variant => (
                BUTTON_SIZES.map(size => (
                    <div className="d-flex gap-2 mb-2 align-items-center">
                        <small className="col-1">
                            {size}
                            {" "}
                            -
                            {" "}
                            {variant}
                        </small>
                        <div className="col-2 align-items-center">
                            <Button key={size + variant} variant={variant} size={size}>Button label</Button>
                        </div>
                        <div className="col-2 text-align-center">
                            <Button key={size + variant} variant={variant} size={size} disabled>Button label</Button>
                        </div>
                        <div className="col-2 text-align-center">
                            <Button
                                key={size + variant}
                                variant={variant}
                                size={size}
                                prefixIcon={<RiAddFill />}
                            >
                                Button label
                            </Button>
                        </div>
                        <div className="col-2 text-align-center">
                            <Button
                                key={size + variant}
                                variant={variant}
                                size={size}
                                postfixIcon={<RiArrowDownSLine />}
                            >
                                Button Label
                            </Button>
                        </div>
                        <div className="col-2 text-align-center">
                            <Button
                                key={size + variant}
                                variant={variant}
                                size={size}
                                postfixIcon={<RiArrowDownSLine />}
                                prefixIcon={<RiAddFill />}
                            >
                                Button label
                            </Button>
                        </div>
                        <div className="col-1 text-align-center">
                            <Button
                                key={size + variant}
                                variant={variant}
                                size={size}
                                prefixIcon={<RiAddLine />}
                            />
                        </div>

                    </div>
                ))
            ))}

            <div className="d-flex gap-3">
                <div className="border">
                    <h3 className="title">Filters</h3>
                    <div>
                        <h4>Inactive</h4>
                        <Button
                            variant="filter"
                            prefixIcon={<RiAddLine />}
                        >
                            Button Label
                        </Button>
                        <Button
                            variant="filter"
                            prefixIcon={<RiAddLine />}
                        />
                    </div>
                    <div>
                        <h4>Inactive</h4>
                        <Button
                            variant="filter"
                            prefixIcon={<RiAddLine />}
                            isActive
                        >
                            Button Label
                        </Button>
                        <Button
                            variant="filter"
                            prefixIcon={<RiAddLine />}
                            isActive
                        />
                    </div>

                </div>
                <div className="border">
                    <h4 className="title">Send</h4>
                    <Button
                        variant="primary"
                        size="small"
                        prefixIcon={<RiSendPlaneFill />}
                        postfixIcon={<RiArrowDownSLine />}
                    />
                </div>
            </div>
        </div>
    );
}

const SECTIONS = [
    {
        name: "Buttons",
        element: AllButtons,
    },
    {
        name: "Alerts",
        element: AllAlerts,
    },
    {
        name: "Toggles",
        element: AllToggles,
    },
    {
        name: "Badges",
        element: AllBadges,
    },
    {
        name: "Navigation",
        element: AllNavigation,
    },
    {
        name: "Inputs",
        element: AllInputs,
    },
];

export default function Theme(): ReactElement {
    return (
        <div>
            {SECTIONS.map(section => (
                <div key={section.name}>
                    <h2>{section.name}</h2>
                    <div data-bs-theme="light" style={{ height: "auto" }} className="p-2">
                        <h3>Light</h3>
                        <section.element />
                    </div>
                    <div data-bs-theme="dark" style={{ height: "auto" }} className="p-2">
                        <h3>Dark</h3>
                        <section.element />
                    </div>
                </div>
            ))}

        </div>
    );
}
